import {lazyRegister} from "@/Core";

// Định nghĩa kiểu dữ liệu cho Scope của Directive
interface IClickOutsideScope extends ng.IScope {
    clickOutside: () => void; // Hàm callback truyền từ HTML
}

class ClickOutsideDirective implements ng.IDirective {
    public restrict = 'A';
    static $inject = ['$timeout'];

    public scope = {
        clickOutside: '&'
    };

    constructor(
        private $timeout: ng.ITimeoutService
    ) {
    }

    // Hàm Link xử lý logic DOM và Event Listener
    public link = (
        scope: IClickOutsideScope,
        element: ng.IAugmentedJQuery): void => {
        const rawElement = element[0]; // Lấy native DOM element

        const onDocumentClick = (event: MouseEvent): void => {
            const target = event.target as HTMLElement;

            // Kiểm tra xem vị trí click có nằm trong element hiện tại không
            const isInside = rawElement === target || rawElement.contains(target);

            if (!isInside) {
                // Sử dụng $apply để thông báo cho AngularJS digest cycle cập nhật lại giao diện
                scope.$apply(() => {
                    scope.clickOutside();
                });
            }
        };

        // Sử dụng $timeout để tránh việc click mở UI bị tính luôn thành click outside ngay lập tức
        this.$timeout(() => {
            document.addEventListener('click', onDocumentClick);
        }, 0);

        // Hủy bỏ lắng nghe sự kiện khi directive bị hủy (Tránh leak bộ nhớ)
        scope.$on('$destroy', () => {
            document.removeEventListener('click', onDocumentClick);
        });
    }
}

lazyRegister.directive('clickOutside', ClickOutsideDirective);
